// extracted by mini-css-extract-plugin
module.exports = {"section":"Main_section__3rRI3","title":"Main_title__nTLYm","info":"Main_info__2GZAD","form":"Main_form__pOkUz","preview":"Main_preview__Se_Lm","egLggN":"Main_egLggN__j6wmE"};